import { render, staticRenderFns } from "./seckill.vue?vue&type=template&id=bec956ee"
import script from "./seckill.vue?vue&type=script&lang=js"
export * from "./seckill.vue?vue&type=script&lang=js"
import style0 from "./seckill.vue?vue&type=style&index=0&id=bec956ee&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports